export const configModel = {
  SET_CONFIG: "[ConfigModel] set config",
};
export const otpModel = {
  SET_OTPDATA: "[ConfigModel] set otp"
};
